import React, { createContext } from 'react'
import { VendorUser } from '../models/VendorUser'
import { Vendor } from '../models/Vendor'

export interface VendorContextInterface {
  profile: VendorUser | null
  setProfile: React.Dispatch<React.SetStateAction<VendorUser | null>>
  companyProfile: Vendor | null
  setCompanyProfile: React.Dispatch<React.SetStateAction<Vendor | null>>
}

export const VendorContext = createContext<VendorContextInterface | null>(null)
